import { TokenResponse, useGoogleLogin } from '@react-oauth/google';

import Button from 'components/Button/Button';

import { ELoginAuthMethod, LoginData } from '../../LoginModal/LoginModal.types';
import { ZENDESK_DOMAIN } from '../constants';
import { GoogleLoginProps } from '../LoginForm.types';


export const GoogleLogin = ({ login, onLoginFailed }: GoogleLoginProps) => {
  const googleLogin = useGoogleLogin({
    onSuccess: (response: TokenResponse) => {
      // Get Zendesk parameters from query params
      const searchParams = new URLSearchParams(window.location.search);
      const origin = searchParams.get('brand_id') || '';
      const returnTo = searchParams.get('return_to') || '';
      const isZendesk = !!origin || window.location.hostname === ZENDESK_DOMAIN;

      const loginData: LoginData = {
        loginToken: response.access_token,
        isZendesk,
        returnTo
      };

      login(
        loginData,
        (success: boolean) => {
          if (success) {
            if (isZendesk && returnTo) {
              return;
            }
            return;
          }
          onLoginFailed();
        },
        ELoginAuthMethod.GOOGLE
      );
    },
    onNonOAuthError: () => {
      onLoginFailed();
    }
  });
  const onGoogleLoginClicked = () => {
    googleLogin();
  };

  return (
    <Button
      variant="outline"
      onClick={onGoogleLoginClicked}
      className="w-full shadow-sm"
      leftIcon={
        <img
          className="w-4 h-4"
          src="https://media.appcharge.com/defaults/google_icon.svg"
          alt="google icon"
        />
      }
    >
      Continue with Google
    </Button>
  );
};
